import { Menu } from "@mantine/core";

import MenuStyles from "./Menu.module.css";

export const menuOverrides = {
  Menu: Menu.extend({
    // Mantine's own default is `returnFocus: true` — every <Menu> in the app
    // now keeps that default, so selecting an item or clicking away from a
    // menu returns keyboard focus to whatever opened it (WCAG 2.4.3). This
    // was previously force-disabled here app-wide (added when upgrading to
    // Mantine 8.3.18, metabase/metabase#72710) because a couple of specific
    // flows intentionally move focus somewhere *else* right after a menu
    // action — e.g. NewItemMenuView (creating a new document/dashboard) and
    // the dashboard "add heading/text/link/iframe" menus (the new card's own
    // inline editor auto-focuses). Restoring the trigger's focus there would
    // fight that. Rather than disabling it for every menu in the app, those
    // specific call sites now opt back out individually with their own
    // `returnFocus={false}` — see each for why.
    defaultProps: {
      radius: "sm",
      shadow: "md",
      withinPortal: true,
    },
    classNames: {
      dropdown: MenuStyles.dropdown,
      item: MenuStyles.item,
      itemSection: MenuStyles.itemSection,
      label: MenuStyles.label,
      divider: MenuStyles.divider,
    },
  }),
};
